import React, { useState } from 'react';
import { createGlobalStyle, ThemeProvider } from 'styled-components';

import { styleReset } from 'react95';
import original from "react95/dist/themes/original";
import ms_sans_serif from "react95/dist/fonts/ms_sans_serif.woff2";
import ms_sans_serif_bold from "react95/dist/fonts/ms_sans_serif_bold.woff2";

import AppBar from './components/AppBar.component';
import Icon from './components/Icon.component';
import Internet from './components/Internet.component';
import MyComputer from './components/MyComputer.component';

const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: 'ms_sans_serif';
    src: url('${ms_sans_serif}') format('woff2');
    font-weight: 400;
    font-style: normal
  }
  @font-face {
    font-family: 'ms_sans_serif';
    src: url('${ms_sans_serif_bold}') format('woff2');
    font-weight: bold;
    font-style: normal
  }
  body {
    font-family: 'ms_sans_serif' !important;
  }
  ${styleReset}
`;

function App() {
  const [showInternet, setShowInternet] = useState(false);
  const [showMyComputer, setShowMyComputer] = useState(false);

  return (
    <div style={{background: 'teal', position: 'relative', height: '100vh'}}>
      <GlobalStyles />
      <ThemeProvider theme={original}>
          <Icon title='The Internet' image='pc2.png' visibleComp={() =>  setShowInternet(true)} />
          <Icon title='My Computer' image='pc.png' visibleComp={() =>  setShowMyComputer(true)} />
          <Icon title='Thrash' image='thrash.png' visibleComp={() => alert("not done")} />
          <Icon title='Dont open' image='pc3.png' visibleComp={() => alert("not done")} />
          <Icon title='About me' image='about.png' visibleComp={() => alert("not done")} />
          
          {
            showInternet?
              <Internet visibleComp={() =>  setShowInternet(false)} />
            : null
          }

          {
            showMyComputer?
              <MyComputer visibleComp={() =>  setShowMyComputer(false)} />
            : null
          }

          <div style={{position: 'absolute', bottom: '5vh', width: '100%'}}> 
            <AppBar />
          </div>
      </ThemeProvider>
    </div>
  );
}

export default App;
